module.exports = __webpack_public_path__ + "img/dot.8a41e3b1.svg";